export const DEFAULT_PAGE_SIZE = 25;
export const DEFAULT_PAGE_SIZE_OPTIONS = [25, 50, 100];

export const INSUFFICIENT_PRIVILEGES = '*Insufficient Privileges*';
